
/**
 * Maps 'sp' properties on a touch-layout spec to their corresponding CSS class names.
 */
const BUTTON_CLASSES = [
  'default',
  'shift',
  'shift-on',
  'special',
  'special-on',
  '', // Key classes 5 through 7 are reserved for future use.
  '',
  '',
  'deadkey',
  'blank',
  'hidden'
];

export default BUTTON_CLASSES;